export default __webpack_public_path__ + "static/media/barmen.9d9998b9.svg";